import React from "react";
import { useUserData } from "../../../hooks/useUserData";
import { getQmsScreen } from "./qmsScreenConfig";
import { getQmsAccessState } from "./qmsPermissionUtils";
import PageBreadcrumb from "../../common/PageBreadcrumb/PageBreadcrumb";
import QmsCommandCenter from "./QmsCommandCenter";

const screen = getQmsScreen("dashboard");

/** QMS compliance dashboard — command center layout (same pattern as eISF). */
const QmsDashboard = () => {
  const { userData, loading: userLoading } = useUserData();

  const access = getQmsAccessState({
    userData,
    isSystemAdmin: userData?.Role === "System Administrator",
    permissionKey: screen?.permissionKey,
    loading: userLoading,
  });

  if (access.status === "loading") {
    return (
      <div className="d-flex justify-content-center p-5">
        <div className="spinner-border" role="status" />
      </div>
    );
  }

  if (access.status === "denied") {
    return (
      <div className="user-mgmt-page isf-cc">
        <PageBreadcrumb
          items={[{ label: "Home", path: "/dashboard" }, { label: screen.title }]}
        />
        <div className="alert alert-warning" role="alert">
          <strong>Access restricted.</strong> {access.message}
        </div>
      </div>
    );
  }

  return <QmsCommandCenter />;
};

export default QmsDashboard;
